import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ModeEditIcon from '@mui/icons-material/ModeEdit'
import {IconButton, ListItemIcon, ListItemText} from '@mui/material'
import {Loading} from '@viptech/react-components'
import {useState} from 'react'
import {Pos} from 'src/common/types/generics/ImageDetections'
import {TranslateBarrierType} from 'src/pages/camera-config/components/object-detection/ObjectDetectionFunctions'
import {BarrierTypeResponse} from 'src/services/api'
import styled from 'styled-components'

type Props = {
  barriers: BarrierTypeResponse[]
  selected: BarrierTypeResponse | null
  onSelectChange: (area: BarrierTypeResponse) => void
  onClickDelete: () => void
  onClickEdit: () => void
}

export const areaHasMultiplePoints = (points: Pos[]) => {
  return points.some((point) => point.reference && point.reference > 1)
}

export function ListBarriersOnCards(props: Props) {
  const {barriers, selected, onSelectChange, onClickDelete, onClickEdit} = props
  const [loadingSelected, setLoadingSelected] = useState<number | undefined>()

  return (
    <WrapperList>
      {barriers.map((it, index) => {
        const isSelected = it.id === selected?.id
        return (
          <ListItemButton selected={isSelected} key={`area-${it}-${index}`} onClick={() => onSelectChange(it)}>
            <ListItemText
              primary={`${it.name}:`}
              secondary={<b style={{fontSize: '11px'}}>{TranslateBarrierType[it.type]}</b>}
              sx={{display: 'flex', alignItems: 'center', gap: '10px'}}
            />
            {isSelected && (
              <>
                {!areaHasMultiplePoints(it.coordinates) && (
                  <ListItemIcon sx={{minWidth: 'inherit'}}>
                    <IconButton sx={{color: '#f4f4f4'}} onClick={() => onClickEdit()}>
                      <ModeEditIcon style={{width: '18px'}} />
                    </IconButton>
                  </ListItemIcon>
                )}
                {loadingSelected === it.id ? (
                  <Loading size='20px' color='white' />
                ) : (
                  <ListItemIcon sx={{minWidth: 'inherit'}}>
                    <IconButton
                      color='error'
                      onClick={() => {
                        setLoadingSelected(it.id)
                        onClickDelete()
                      }}>
                      <DeleteOutlineIcon style={{width: '18px'}} />
                    </IconButton>
                  </ListItemIcon>
                )}
              </>
            )}
          </ListItemButton>
        )
      })}
    </WrapperList>
  )
}

const ListItemButton = styled.div<{selected: boolean}>`
  border-radius: 8px;
  height: 35px;
  display: flex;
  padding: 4px 4px 4px 8px;
  border: 1px solid #d1d1d1;
  color: ${({selected}) => selected && 'white'};
  background-color: ${({selected}) => (selected ? '#009EFF' : 'white')};

  :hover {
    background-color: ${({selected}) => (selected ? '#009EFF' : 'white')};
    transition: opacity 0.15s ease-in-out;
  }
`

const WrapperList = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  row-gap: 10px;
`
